import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./views/homePage/HomePage";
import { CssBaseline, StylesProvider, ThemeProvider } from "@material-ui/core";
import theme from "./utils/Theme";
import Footer from "./components/Footer";
import { MintPage } from "./views/mintPage/MintPage";

function App() {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          {/* <NavBar setNavBarHeight={setNavBarHeight} /> */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="mint" element={<MintPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
